<template>
  <!-- Container -->
  <b-row class="reset-password-type-container" align-v="center" align-h="start">
    <!-- Omit password -->
    <b-link variant="primary"
            class="reset-password-type-link"
            @click="resetPassword">
      Réinitialiser le mot de passe
    </b-link>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ResetPasswordType',
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    ...mapGetters([
      'getUserShowed',
    ]),
    resetPassword(event) {
      event.preventDefault();
      event.stopPropagation();
      const email = this.getUserShowed().email;
      this.$store.commit('setGlobalSpinnerShow', true);
      this.$store.dispatch('resetPassword', { email })
        .then(() => {}, () => {})
        .finally(() => {
          // Show success toast
          const toast = {
            show: true,
            message: `Un email de confirmation a été envoyé à l'adresse ${email}`,
            variant: 'success',
            duration: 5000,
          };
          this.$store.commit('setGlobalToaster', toast);
          // Stop spinner
          this.$store.commit('setGlobalSpinnerShow', false);
        })
      ;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .reset-password-type-container {
    padding-left: 15px;
    .is-active-check-button {
      display: inline-block;
      margin-left: 17px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/user/ResetPasswordType.vue